<div class="layout-content mt-3">
	<div class="grid">
		<div [ngClass]="col4ResponsiveStd()" class="flex flex-column justify-content-start text-center" *ngFor="let site of sites;">
			<div class="flex justify-content-center align-items-center">
				<p-checkbox [ngModel]="assigned(site)" [binary]="true"
					[disabled]="!canChange(site)"
					(onChange)="onCheckChange($event.checked, site)"
					[label]="getTruncateNameDescr(site)"
				>
				</p-checkbox>
			</div>
			<small *ngIf="anyOpenTicketOn(site)" class="flex align-items-center justify-content-center text-50 pt-1">{{ 'SITE_HAS_OPEN_TICKETS' | translate }}</small>
		</div>
	</div>

	<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<button type="button" pButton pRipple (click)="closeDialog()"
			label="{{ 'CLOSE' | translate }}"
			class="p-button-secondary text-xl font-normal mt-2 mx-1"
			[ngClass]="dynamicButtonWidth()">
		</button>
	</div>
</div>
